<template>
  <li>
    <div class="d-flex gap-3">
      <div>
        <div class="comment-user">
          <img
            :src="(comment.author || {}).avatar_url ? (comment.author || {}).avatar_url : require('@/assets/img_avatar.png')"
            alt="user image" />
        </div>
      </div>
      <div class="col comment-body">
        <div class="d-flex gap-2 flex-wrap">
          <h6 class="text-info">{{ (comment.author || {}).user_name }}</h6>
          <small class="m-0 text-muted" v-if="(comment.author || {}).grade"> - {{ (comment.author || {}).grade
          }}</small>
        </div>

        <div class="comment-content">
          <p class="m-0">{{ comment.comment }}</p>
        </div>
        <div class="d-flex gap-2 flex-wrap">
          <p class="comment-footer m-0">{{ comment.created_at }}</p>
          <span class="comment-footer" v-if="!$route.name !== 'video_comment'"> • </span>
          <router-link
            :to="`/admin/lessons/view_lesson/${$route.params.index}/${this.$route.params.video_id}/comments/${comment.parent_id}`"
            class="comment-footer m-0" v-if="!$route.name !== 'video_comment'">{{ comment.replies_count }} {{
                comment.replies_count > 2 ? 'ردود' : 'رد'
            }}</router-link>
        </div>
        <!-- replies -->
        <ul class="comments-replies-list py-4 px-0" v-if="comment.replies_count !== 0">

          <SingleReplyItem
            v-for="(item, index) in $route.name === 'video_comment' ? Object.values((comment.replies || {})) : Object.values((comment.replies || {})).slice(0, 2)"
            :key="index" :reply="item" />

        </ul>
        <!-- ./replies -->

        <!-- add reply form -->
        <form class="w-100" @submit.prevent="createNewComment" v-if="$route.name !== 'video_comment'" v-show="active">
          <div class="d-flex flex-lg-row flex-column gap-2 gap-lg-3 align-items-end">
            <div class="col-lg w-100">
              <div class="form-group m-0">
                <textarea class="form-control m-0" id="reply-content" name="reply-content" placeholder="اكتب ردك هنا.."
                  required style="min-height: 50px" v-model="add_data.reply">
                </textarea>
              </div>
            </div>
            <div>
              <button class="btn btn-dark" type="submit" :disabled="add_disabled || !add_data.reply">
                <i class="fas fa-spinner fa-spin" v-if="add_disabled"></i>
                ارسال ردك
              </button>
            </div>
          </div>
        </form>
        <!-- ./add reply form -->
      </div>
      <div class="comment-reply-action">
        <button class="reply-btn" v-if="$route.name !== 'video_comment'" @click.prevent="active = !active"><i
            class="fas fa-reply"></i></button>
        <button class="delete-btn" @click.prevent="deleteCurrentItem(comment, 'comment')"><i
            class="fas fa-trash"></i></button>
      </div>
    </div>
  </li>
</template>

<script>
import { Timestamp } from '@firebase/firestore';
import { mapActions, mapGetters } from 'vuex';

import SingleReplyItem from './SingleReplyItem.vue';
export default {
  name: 'SingleCommentItem',
  components: { SingleReplyItem },
  props: {
    comment: {
      type: Object,
      default: Object,
    },
  },
  data() {
    return {
      id: this.$route.params.video_id,
      lesson_id: this.$route.params.index,
      comment_id: this.comment.parent_id,
      add_data: {},
      add_disabled: false,
      active: false,
    };
  },
  computed: {
    ...mapGetters('adminModule', ['getUser']),
  },
  created() {
    console.log(Object.values((this.comment?.replies || {})))
  },
  methods: {
    ...mapActions('ViewVideoModule', ['addReply', 'getSelectedComment', 'deleteItem']),
    async createNewComment() {
      const user = this.getUser;
      const data = {
        comment: this.add_data.reply,
        comment_id: this.comment_id,
        created_at: new Date().toDateString(),
        created_date: Timestamp.now().toDate().toISOString(),

        content_id: this.id,
        user_id: user.uid,
        author: { avatar_url: user.photo, user_name: `${user.firstName} ${user.lastName}`, user_id: user.uid, grade: null, is_teacher: true },
      };
      this.$route.name !== 'video_comment' &&
        (await this.getSelectedComment({
          video_id: this.id,
          comment_id: this.comment_id,
        }));
      await this.addReply({
        video_id: this.id,
        reply: data,
        path: this.$route.path,
        comment_id: this.comment_id,
      });
      // remove data
      this.add_data = {};
    },
    deleteCurrentItem(item, type) {
      this.deleteItem({
        type,
        item,
        path: this.$route.path,
      });
    },
  },
};
</script>
